<template>
  <v-container
    fluid
    class="pa-0">
    <v-layout wrap>
      <v-flex
        v-for="n of 6"
        :key="n"
        xs6
        md4>
        <MemoryCardSkeleton :isTwoLine="isTwoLine" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MemoryCardSkeleton from './MemoryCardSkeleton';

export default {
  components: {
    MemoryCardSkeleton,
  },
  props: {
    isTwoLine: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
